<template>
	<div class="l-container">
		<div class="error">
			<strong class="tit">Error</strong>
			<div class="error-msg">
				<strong>요청하신 페이지를 찾을 수 없습니다.</strong>
				<p>
					해당 페이지는 경로가 변경되었거나, 서버에 존재하지 않습니다.<br />파일의
					경로가 정확한지, URL 주소를 바르게 입력했는지 확인해주세요.
				</p>
				<route-link @click="$router.go(-1)">뒤로 가기</route-link>
				<route-link to="/">메인 페이지로 이동</route-link>
			</div>
			<div class="l-pc">
				<div class="address">
					<br />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ErrorPage",
	metaInfo: {
		title: "Error",
	},
	data() {
		return {
			currentRoute: window.location.pathname,
		};
	},
	mounted: function () {},
	methods: {},
	components: {
		//    'app-header': Header,
		//    'app-footer': Footer
	},
};
</script>


// WEBPACK FOOTER //
// src/components/Error.vue